import type { ContestTrigger } from '../../../../../../dorian-shared/types/event/Event';

export enum ContestRewardType {
  Sapphires = 'sapphires',
  Hearts = 'hearts',
}

export enum ContestDeliveryType {
  Immediate = 'immediate',
  Mail = 'mail',
}

export interface ContestTriggerFormValues {
  triggerKey: string
  episodeUuid: string
  rewardType: ContestRewardType
  rewardAmount: number
  deliveryType: ContestDeliveryType
  title: string
  message: string
}

export function createEmptyContestTriggerValues(): ContestTriggerFormValues {
  return {
    triggerKey: '',
    episodeUuid: '',
    rewardType: ContestRewardType.Sapphires,
    rewardAmount: 0,
    deliveryType: ContestDeliveryType.Immediate,
    title: '',
    message: '',
  };
}

export function contestApiToFormValues(
  contest: ContestTrigger | null | undefined,
): ContestTriggerFormValues {
  if (!contest) {
    return createEmptyContestTriggerValues();
  }
  const rewardType = contest.rewardType === ContestRewardType.Hearts
    ? ContestRewardType.Hearts
    : ContestRewardType.Sapphires;
  return {
    triggerKey: contest.triggerKey ?? '',
    episodeUuid: contest.episodeUuid ?? '',
    rewardType,
    rewardAmount: Number(contest.rewardAmount) || 0,
    deliveryType: ContestDeliveryType.Immediate,
    title: contest.title ?? '',
    message: contest.message ?? '',
  };
}

export const CONTEST_TRIGGER_MAX = {
  trigger: 200,
  title: 500,
  message: 10000,
} as const;

/** True when saved or in-progress contest data should show the full section (not the "Add" affordance). */
export function isContestTriggerPopulated(v: ContestTriggerFormValues): boolean {
  const t = (s: string) => String(s ?? '').trim();
  return Boolean(
    t(v.triggerKey)
    || t(v.episodeUuid)
    || t(v.title)
    || t(v.message),
  );
}
